export default {
  backLinks: [],
  isCastRunning: false,
  joinRoomPopup: false,
  joinCastPopup: false,
  isRoomRunning: false,
  castRunningBoardsName: [],
  castInstalledBoardsName: [],
  roomRunningBoardsName: [],
  roomInstalledBoardsName: [],
};
